import ShapeBase from './ShapeBase';
import shapeCalloutBox from '../assets/icons/shapeCalloutBox.svg';
import { svgToIcon } from '../utils/svg';
import { AttachmentPoint } from '../types';
import { pathDataToPath } from './utils';
import ShapeRoundRect from './ShapeRoundRect';
import { makeSimplePath } from '.';

// Corner radius as a percentage.
const CORNER_RADIUS = 0.05;

class ShapeCallOutBox extends ShapeBase {
  static renderIcon() {
    return svgToIcon(shapeCalloutBox);
  }

  // Connect the bottom connector to the arrow of the callout.
  static connectControlDefinition() {
    return {
      ...super.connectControlDefinition(),
      [AttachmentPoint.Bottom]: {
        x: -0.1667,
        y: 0.5,
        normal: { x: 0, y: 1 },
        oppositeAttachmentPoint: AttachmentPoint.Top,
      },
    };
  }

  // Similar to rounded rectangles, we need rounded corners that scale
  render(ctx: CanvasRenderingContext2D) {
    const obj = this.fabricObject;
    const w = obj.width;
    const h = obj.height;
    const r = Math.min(w * obj.scaleX, h * obj.scaleY) * CORNER_RADIUS;
    const rx = r / obj.scaleX;
    const ry = r / obj.scaleY;

    ctx.beginPath();
    this._setBorderDash(ctx);
    ctx.moveTo(-w / 2 + rx, -h / 2);
    ctx.lineTo(w / 2 - rx, -h / 2);
    ctx.ellipse(w / 2 - rx, -h / 2 + ry, rx, ry, 0, -Math.PI / 2, 0);
    ctx.lineTo(w / 2, h / 4 - ry);
    ctx.ellipse(w / 2 - rx, h / 2.5 - ry, rx, ry, 0, 0, Math.PI / 2);

    // triangle part
    ctx.lineTo(-w / 16, h / 2.5);
    ctx.lineTo(-w / 6, h / 2);
    ctx.lineTo(-w / 6, h / 2.5);

    ctx.ellipse(-w / 2 + rx, h / 2.5 - ry, rx, ry, 0, Math.PI / 2, Math.PI);
    ctx.lineTo(-w / 2, h / 2.5 - ry);
    ctx.ellipse(-w / 2 + rx, -h / 2 + ry, rx, ry, 0, Math.PI, 1.5 * Math.PI);
    ctx.closePath();

    obj._renderPaintInOrder(ctx);
  }

  edgePaperPath(): paper.Path {
    // reuse ShapeRoundRect's path since it's the same except for the arrow
    return pathDataToPath(
      makeSimplePath(ShapeRoundRect.pathString(CORNER_RADIUS)),
      this.fabricObject,
      this.width,
      this.height
    );
  }
}

export default ShapeCallOutBox;
